import React from 'react';
import {
  arrayOf,
  func,
  object,
  oneOf,
  oneOfType,
  shape,
  string,
} from 'prop-types';
import { isFunc } from 'vdlib';
import { Row, Collapse } from 'antd';
import TextFilter from 'components/tables/filters/TextFilter';
import DropdownFilter from 'components/tables/filters/DropdownFilter';
import DateFilter from 'components/tables/filters/DateFilter';
import { FilterOutlined } from '@ant-design/icons';
import styles from './styles';

const { Panel } = Collapse;

const FiltersList = props => {
  const { filters, filterData, location, setFilter } = props;
  // returns a default filter if location filters correspond to location
  const extractFilter = React.useMemo(() => {
    const { Value: locationFilterValue } = Array.isArray(filters)
      ? filters.find(x => x.Name === 'forLocation') || {}
      : {};
    const defaultValueFormatter = value => value || null;
    return locationFilterValue === location.pathname
      ? (name, valueFormatter) => {
          const { Value: filterValue } = filters
            ? filters.find(f => f.Name === name) || {}
            : {};
          return isFunc(valueFormatter)
            ? valueFormatter(filterValue)
            : defaultValueFormatter(filterValue);
        }
      : () => null;
  }, [filters, location]);

  return (
    <Collapse defaultActiveKey={['1']}>
      <Panel
        header={
          <div>
            <FilterOutlined style={styles.filterOutlined} />
            <div style={styles.title}>Filters</div>
          </div>
        }
        key="1"
      >
        <Row>
          {filterData.map(({ name, optionsProp, type, ...rest }) => {
            const filterProps = {
              defaultValue: extractFilter(name),
              name,
              onSetFilter: setFilter,
              options: optionsProp ? props[optionsProp] : null,
              ...rest,
            };
            const FilterComponent =
              type === 'dropdown'
                ? DropdownFilter
                : type === 'date'
                ? DateFilter
                : TextFilter;
            return <FilterComponent key={name} {...filterProps} />;
          })}
        </Row>
      </Panel>
    </Collapse>
  );
};

FiltersList.propTypes = {
  // all filter configuration
  filterData: shape({
    name: string,
    title: string,
    optionsProp: string,
    placeholder: oneOfType([arrayOf(string), string]),
    type: oneOf(['date', 'dropdown, text']),
  }),
  // filter values from redux
  filters: arrayOf(shape({ Name: string, Value: string })),
  location: object,
  setFilter: func,
};

export default FiltersList;
